import React from 'react';

export function useAccordionHoverAndSelect(delay = 150) {
  const [hoveredValue, setHoveredValue] = React.useState<string | null>(null);
  const [selectedValue, setSelectedValue] = React.useState<string | null>(null);
  const hoverTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = (value: string) => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    hoverTimeoutRef.current = setTimeout(() => setHoveredValue(value), delay);
  };

  const handleMouseLeave = () => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    setHoveredValue(null);
  };

  const handleClick = (value: string) => {
    // Clear hover so clicks always take full control of expansion state.
    // This ensures a second click on the same item collapses it even if it was hovered.
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    setHoveredValue(null);
    setSelectedValue(current => (current === value ? null : value));
  };

  React.useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    };
  }, []);

  const expandedValue = selectedValue || hoveredValue;

  return {
    expandedValue,
    selectedValue,
    handleMouseEnter,
    handleMouseLeave,
    handleClick,
    isHighlighted: (value: string) => expandedValue === value,
  };
}
